import React from "react";
import AndroidIcon from "../../Home/static/images/androidPlayIcon.png";
import "../static/index.css";
import UpperBody from "./UpperBody";
import ArtistReview from "./ArtistReview";
import {
  APPLE_STORE_DOWNLOAD_LINK,
  GPLAY_DOWNLOAD_LINK,
} from "../../../utils/consts";
import BodyDescription from "./BodyDescription";
import { Helmet } from "react-helmet";
export default function Body() {
  return (
    <div className="homepageBody d-flex flex-column justify-content-center align-items-center">
      <Helmet>
        <title>Artist Page</title>
      </Helmet>
      <div className="artistMusicPoster">
        <div className="artistPosterText col-xl-7 col-lg-7 col-md-7 col-sm-7 col-10 pl-sm-2 pl-2">
          Ombré for Artists
        </div>
        <div className="artistPosterText2 col-xl-10 col-lg-10 col-md-10 col-sm-7 col-10 pl-sm-2 pl-2">
          -Your musical Brand
        </div>
        <div className="posterDescription col-8 mt-xl-4 mt-lg-4 mt-md-4">
          Interact and Engage with true fans, and
          <br />
          Monetize your Music Activities. Launch your page.
        </div>
        <div className="d-flex flex-row downloadButtonsContainer artistDownloadButtonContainer mt-lg-4 mt-md-3 mt-sm-5 mt-xl-7 pb-xl-5 pb-lg-5 pb-md-3 pb-sm-3 pb-3 pl-sm-2 pl-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={GPLAY_DOWNLOAD_LINK}
          >
            <div className="androidButton bg-white d-flex flex-row px-xl-4 px-lg-4 px-md-3 px-sm-4 px-3 py-2 mr-4">
              <img
                className="downloadIcon"
                src={AndroidIcon}
                alt="Android Play Icon"
              />

              <div className="androidButtonText ml-sm-2 ml-2 my-auto">
                Android
              </div>
            </div>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={APPLE_STORE_DOWNLOAD_LINK}
            className="anchor"
          >
            <div className="iosButton d-flex flex-row bg-white px-xl-4 px-lg-4 px-md-3 px-sm-4 px-3 py-2">
              <i className="fab fa-apple appleIcon"></i>
              <div className="iosButtonText my-auto ml-lg-3 ml-lg-3 ml-md-3 ml-sm-2 ml-2">
                iOS
              </div>
            </div>
          </a>
        </div>
      </div>
      <UpperBody />

      <BodyDescription />
      <ArtistReview />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Artist/components/Body.jsx